export default __webpack_public_path__ + "static/media/ProtectionDonneesPersonnelles.0a225a1d.md";